import { useMutation } from 'react-query';
import { deleteImports } from './delete-imports';

function useDeleteImport(importId, options) {
  return useMutation((importId) => deleteImports(importId), options);
}

export { useDeleteImport };
